
































































































































































































import { Component, Prop, Watch, Ref } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import BaseSuketCard from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketCard.vue";
// import StoreSuketSehatTHT from "@/store/modules/SuketSehatTHT";
import SuketSehatTHTInputCard from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SuketSehatTHTInputCard.vue";
import CommonSuket, { EnSuketCategory } from "@/services/CommonSuket";
import BaseSuketTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketTabPage";

import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { getAge, formatDMYDate } from "@/utility/DateUtils";
import { storeDokter } from "@/store/modules/dokter";
import moment from "moment";
import SuketLayakTerbang from "@/store/modules/SuketLayakTerbang";
import {
  SuketBaseWithRelationship,
  SuketLayakTerbangInterface
} from "@/types/common_surat_keterangan";
import PDFViewer from "@/components/PDFViewer.vue";

@Component({
  components: {
    CardModalTtd,
    BaseSuketCard,
    SuketSehatTHTInputCard,
    PDFViewer
  }
})
export default class SuketLayakTerbangTabPage extends BaseSuketTabPage {
  @Prop() declare readonly register: string | number;
  @Ref() pdfEl: any;

  allowedUnit = ["*"];
  suketSvc = new CommonSuket(EnSuketCategory.LayakTerbang);
  suketStore = SuketLayakTerbang;

  get pdfUrl() {
    return this.dataSuket
      ? this.getSuketPdfUrl(EnSuketCategory.LayakTerbang, this.dataSuket.id)
      : null;
  }

  register_id = this.register;
  pasien_rm = this.pasien.rm;
  unit_id = this.user.unit_id;
  nama = this.pasien.nama;
  umur = getAge(formatDMYDate(this.pasien.tgl_lahir))
    .toString()
    .concat(" Th");

  surat_date = moment().format("YYYY-MM-DD");
  signee_user_id = this.user.id;
  creator_user_id = this.user.id;
  alamat_type = "ktp";

  diagnosis = null;
  tglFlight = null;
  today = moment().format("YYYY-MM-DD");
  tglFlightShow = false;
  flightFrom = null;
  flightTo = null;

  validasi = [v => !!v || "*Kolom ini harus diisi"];
  modalTtdSkJiwa = false;
  saving = false;

  mounted() {
    this.register_id = this.dataSuket?.register_id || this.register;
    this.pasien_rm = this.dataSuket?.pasien_rm || this.pasien.rm;
    this.unit_id = this.dataSuket?.unit_id || this.user.unit_id;
    this.nama = this.pasien.nama;
    this.umur =
      this.dataSuket?.pasien.umur_th ||
      getAge(formatDMYDate(this.pasien.tgl_lahir))
        .toString()
        .concat(" Th");

    this.surat_date = this.dataSuket?.surat_date || new Date();
    this.signee_user_id = this.dataSuket?.signee_user_id || this.user.id;
    this.creator_user_id = this.dataSuket?.creator_user_id || this.user.id;
    this.alamat_type = this.dataSuket?.content.alamat_type;

    this.diagnosis = this.dataSuket?.content?.diagnosis;
    this.tglFlight = this.dataSuket?.content?.flight_date;
    this.today = moment().format("YYYY-MM-DD");
    this.tglFlightShow = false;
    this.flightFrom = this.dataSuket?.content?.flight_from;
    this.flightTo = this.dataSuket?.content?.flight_to;
  }

  get pasien() {
    return storePasien.identitasPasien;
  }

  get alamatOptions() {
    const opts = [
      {
        id: "ktp",
        name: this.pasien.alamat,
        category: "Alamat KTP"
      }
    ];

    if (this.pasien.alamat_domisili) {
      opts.push({
        id: "domisili",
        name: this.pasien.alamat_domisili,
        category: "Alamat Domisili"
      });
    }

    return opts;
  }

  get user() {
    return userModule.user;
  }

  get input() {
    return {
      register_id: this.register_id,
      pasien_rm: this.pasien_rm,
      unit_id: this.unit_id,
      content: {
        alamat_type: this.alamat_type,
        diagnosis: this.diagnosis,
        flight_date: this.tglFlight,
        flight_from: this.flightFrom,
        flight_to: this.flightTo
      },
      surat_date: this.surat_date,
      signee_user_id: this.signee_user_id,
      creator_user_id: this.creator_user_id
    };
  }

  get listDokter() {
    return storeDokter.list;
  }

  get canSign() {
    return this.user.id == this.signee_user_id;
  }

  save() {
    if (!this.saving) {
      this.saving = true;

      const action = this.dataSuket
        ? this.suketSvc.update(this.dataSuket.id, this.input)
        : this.suketSvc.create(this.input);

      action
        .then(() => {
          if (this.canSign) {
            this.showSignatureModal();
          }

          appModule.NoticeDelay("Berhasil Simpan");

          this.close();
          this.suketStore.getSuketByRegister(this.register);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  close() {
    this.expandInput = false;
  }

  tglFlightFormat() {
    return this.tglFlight
      ? moment(this.tglFlight, "YYYY-MM-DD").format("DD MMMM YYYY")
      : "";
  }

  print() {
    this.pdfEl.print();
  }

  @Watch("dataSuket")
  changeDataSuket(val: SuketBaseWithRelationship<SuketLayakTerbangInterface>) {
    if (val) {
      this.register_id = val.register_id;
      this.pasien_rm = val.pasien_rm.toString();
      this.unit_id = val.unit_id;
      this.nama = val.pasien.nama;
      this.umur = val.pasien.umur_th;
      this.surat_date = val.surat_date;
      this.signee_user_id = val.signee_user_id;
      this.creator_user_id = val.creator_user_id;
      this.alamat_type = val.content.alamat_type;
      this.diagnosis = val.content.diagnosis;
      this.tglFlight = val.content.flight_date;
      this.flightFrom = val.content.flight_from;
      this.flightTo = val.content.flight_to;
    } else {
      this.register_id = this.register;
      this.pasien_rm = this.pasien.rm;
      this.unit_id = this.user.unit_id;
      this.nama = this.pasien.nama;
      this.umur = getAge(formatDMYDate(this.pasien.tgl_lahir))
        .toString()
        .concat(" Th");
      this.surat_date = null;
      this.signee_user_id = this.user.id;
      this.creator_user_id = this.user.id;
      this.alamat_type = "ktp";
      this.diagnosis = null;
      this.tglFlight = null;
      this.flightFrom = null;
      this.flightTo = null;
    }
  }
}
